"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  vesselInfo: {
    title: '船舶信息查询',
    vesselCode: '船舶代码',
    vesselName: '船舶名称',
    callSign: '呼号',
    result: '船舶信息查询结果',
    vesselNationality: '船籍',
    imoCode: 'IMO代码',
    classfication: '船级',
    grossTon: '总吨',
    netTon: '净吨',
    dwt: '载重吨(DWT)',
    totalTeu: '合计(TEU)',
    buildDate: '建造日期',
    validateNul: '请输入查询条件'
  },
  button: {
    search: '查询'
  }
};